import React from 'react';

export const FileUploadDropZone = ({
  canUpload,
  dragOver,
  dragHandlers,
  onOpenPicker,
}) => {
  if (canUpload) {
    return (
      <div
        className={`file-upload-block__drop${dragOver ? ' is-dragover' : ''}`}
        {...dragHandlers}
        onClick={onOpenPicker}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onOpenPicker();
          }
        }}
        role="button"
        tabIndex={0}
      >
        <span className="file-upload-block__drop-full">
          Drop a file or click to upload
        </span>
        <span className="file-upload-block__drop-short">Upload</span>
      </div>
    );
  }

  return (
    <div className="file-upload-block__drop is-locked">
      <span className="file-upload-block__drop-full">
        Fills when this doc is opened from a mission
      </span>
      <span className="file-upload-block__drop-short">On a mission</span>
    </div>
  );
};
